import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../lib/api';
import { setToken } from '../lib/auth';

export function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { token } = await auth.login(password);
      setToken(token);
      navigate('/friends');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'ログインに失敗しました');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-name">
            one fifty<b>.</b>
          </div>
          <div className="login-brand-sub">ADMIN CONSOLE</div>
        </div>
        <div className="login-title">管理者ログイン</div>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="field-label">パスワード</label>
            <input
              className="input"
              type="password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center' }}
            disabled={submitting || !password}
          >
            {submitting ? 'ログイン中...' : 'ログイン'}
          </button>
          {error && <div className="login-error">{error}</div>}
        </form>
      </div>
    </div>
  );
}
